import request from "@/utils/request.js"
let messageApi = {
	// 获取环信token
	getHxToken() {
		return request({
			url: `/im/msg/getUserToken`,
			method: 'get',
			token: uni.getStorageSync('token')
		})
	},
	// 发送环信消息
	sendMsg(data) {
		return request({
			url: `/im/msg/sendMsg`,
			method: 'post',
			data,
			token: uni.getStorageSync('token')
		})
	},
	// 获取系统消息 /need/message/list
	getSysMsgList(data) {
		return request({
			url: "/need/message/list",
			method: 'get',
			data,
			token: uni.getStorageSync('token'),
			isHideLoading: true
		})
	},
	// 获取群成员信息
	getGroupPersons(groupId, fromHxId) {
		return request({
			url: `/other/getOtherGroupInfo?groupId=${groupId}&fromHxId=${fromHxId}`,
			method: 'get',
			token: uni.getStorageSync('token')
		})
	},
	//热门问题
	bangzhuzhongxin(data) {
		return request({
			url: `/web/notice/list`,
			method: 'get',
			data
		})
	},
	// 用户备注列表
	userRemarkList(fromHxId, toHxId = '') {
		return request({
			url: `/userRemark/list?fromHxId=${fromHxId}&toHxId=${toHxId}`,
			method: 'get',
			token: uni.getStorageSync('token')
		})
	},
	// 查询系统字典表
	getDict(dictType) {
		return request({
			url: "/system/dict/data/type/" + dictType,
			method: 'get',
			token: uni.getStorageSync('token')
		})
	},
	//推送 云函数
	pushMsg(data) {
		return request({
			url: "/push",
			method: 'post',
			data,
			domain: '/unicloud'
		})
	},
	// 获取群详情信息
	getGroupDetailInfo(id) {
		return request({
			url: `/group/info/${id}`,
			method: 'get',
			token: uni.getStorageSync('token'),
			isHideLoading: true
		})
	},
	// 首次打开APP时通知后台
	pushYx(data) {
		return request({
			url: `/web/pushYx`,
			method: 'get',
			isHideLoading: true,
			data
		})
	},

	// 查询当前用户的会话列表
	getSessionList(data) {
		return request({
			url: `/sessionList/h5/list`,
			method: 'get',
			data,
			isHideLoading: true,
			token: uni.getStorageSync('token')
		})
	},
	// 会话历史消息记录  type 1往前  2往后  3上下
	getHistoryMessageCustom(sessionId, id = '', type = 1, limit = 20) {
		return request({
			url: `/msg/history/recentList?sessionId=${sessionId}&type=${type}&limit=${limit}&id=${id}`,
			method: 'get',
			isHideLoading: true,
			token: uni.getStorageSync('token')
		})
	},





}

export default messageApi